import { Box, Button, Card, CardContent, CardHeader, Container, Link, makeStyles, MuiThemeProvider, Paper, Typography, useMediaQuery } from '@material-ui/core';
import { useBranch } from '@zennya/web-component-library/src/components/BranchIO/BranchProvider';
import clsx from 'clsx';
import isEmpty from 'lodash.isempty';
import { analyticsIdentifierState, openChatState } from 'pages/CustomerBooking';
import { Chat } from 'pages/CustomerBooking/Chat';
import { HeaderPillow } from 'pages/CustomerBooking/HeaderPillow';
import { NotFound } from 'pages/NotFound';
import Qrcode from "qrcode.react";
import { useCallback, useEffect, useMemo } from 'react';
import { PinInput } from 'react-input-pin-code';
import { Redirect, useHistory } from 'react-router-dom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { requestWhitelabelVerification, testLogEventWhitelabel, useUserState } from 'services/authentication.service';
import themes from 'themes';
import { HelvNeue } from 'themes/theme';
import { useRunOnce, useState } from 'util/stateref';
import { useUrlState } from '@zennya/web-component-library/src'
import { useTrackEvent } from 'util/trackEvent';
import { CustomToaster } from 'components/CustomToaster';
import { BookingNotFound } from 'pages/CustomerBooking/Details/BookingNotFound';

const BP_MOBILE = 960

const useStyles = makeStyles((theme) => {
  return {
    link: {
      textDecoration: 'none',
    },
    code: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: theme.spacing(2)
    },
    codeInput: {
      backgroundColor: `${theme.palette.background.paper} !important`,
    },
    action: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: theme.spacing(2)
    },
    centerCard: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      textAlign: "center",
      "& > *:first-child": {
        marginTop: theme.spacing(3)
      }
    },
    strong: {
      fontWeight: 'bold'
    },
    root: {
      backgroundColor: '#fff',
      height: '100%',
      width: '100%',
    },
    roundBack: {
      height: `100%`,
      borderRadius: theme.shape.borderRadius,
      display: 'flex',
      flexDirection: 'row',
      backgroundColor: theme.palette.primary.main,
      [theme.breakpoints.down(BP_MOBILE)]: {
        margin: 0,
        height: '100%',
        width: '100%',
        backgroundColor: 'white',
        flexDirection: 'column',
      },
    },
    btnGroup: {
      paddingTop: theme.spacing(4),
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "center",
      "& > *": {
        minWidth: '45%',
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginBottom: theme.spacing(2)
      }
    },
    leftBox: {
      flex: '1 1 50%',
      borderRadius: theme.shape.borderRadius,
      display: 'flex',
      flexDirection: "column",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: theme.palette.primary.main,
      [theme.breakpoints.down(BP_MOBILE)]: {
        background: "linear-gradient(268.89deg, #7F8AAC 12.95%, #74BACD 97.46%)",
        borderRadius: 0,
        flex: '0 0 0%',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
      },
    },
    title: {
      ...theme.typography.h2,
      [theme.breakpoints.down(BP_MOBILE)]: {
        ...theme.typography.h6,
      }
    },
    rightBox: {
      flex: '1 1 50%',
      borderRadius: theme.shape.borderRadius,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.palette.primary.whisper,
      [theme.breakpoints.down(BP_MOBILE)]: {
        backgroundColor: 'white',
        // flexDirection: 'column-reverse',
      },
    },
    bookingBox: {
      flex: '1 1 50%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: theme.spacing(8),
      [theme.breakpoints.down(BP_MOBILE)]: {
        padding: 0
        // flexDirection: 'column-reverse',
      },
      margin: theme.spacing(2),
    },
    handBox: {
      position: 'relative',
      flex: '1 1 50%',
      filter: "contrast(100%) brightness(100%)",
      background: "linear-gradient(60deg, rgba(187,228,228,1), rgba(127, 138, 172, .5)), url(/assets/images/cloudp.svg)",
      '&>img': {
        maxHeight: '121%',
        maxWidth: '100%',
        position: 'absolute',
        bottom: 0,
        [theme.breakpoints.down(BP_MOBILE)]: {
          // left: '46.5%',
          display: 'none'
        },
        left: '43%',
        transform: "translateX(calc(-50% - 45px))",
      },
      [theme.breakpoints.down(BP_MOBILE)]: {
        minHeight: '200px',
        marginTop: 60
      },

    },
    helvetica: {
      fontFamily: HelvNeue
    },
    qrBox: {
      marginTop: theme.spacing(2),
    },
    cardHeader: {
      textAlign: 'center'
    },
    insideBanner: {
      background: "linear-gradient(268.89deg, #7F8AAC 12.95%, #74BACD 97.46%)",
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      width: '100%',
      marginBottom: theme.spacing(2),
      color: theme.palette.background.paper,
      fontWeight: 'bold',
    }
  }
})
const ExistingAccount = ({ match, location }) => {
  const classes = useStyles()

  const validationState = location?.state
  const [identityResult, setIdentityResult] = useState();
  const serviceId = match?.params?.serviceId
  const whiteLabelCustomerId = location?.state?.white_label_customer?.id
  const validationMessage = location?.state?.validation_message

  const [booking, setBooking] = useState(null);

  const chatOpen = useRecoilValue(openChatState);
  const setChatOpen = useSetRecoilState(openChatState);

  const [loading, setLoading] = useState();
  const [fingerprint, setFingerprint] = useState();
  const history = useHistory()

  const { fetchBookingByAuth } = useUserState()
  const [analyticsIdentifier, setAnalyticsIdentifier] = useRecoilState(analyticsIdentifierState);

  const [medium, setMedium] = useUrlState({
    queryKey: 'medium',
  });

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down(BP_MOBILE), {
    noSsr: true,
  });

  const trackEvent = useTrackEvent(match?.params?.serviceId)

  const [identityMatch, setIdentityMatch] = useState('email');

  const { deepLink, generateDeeplink } = useBranch({
    apiKey: process.env.REACT_APP_BRANCH_API_KEY,
  });

  const fetchAuthOrBooking = useCallback(
    async () => {
      setLoading(false);
      const result = await fetchBookingByAuth(serviceId, analyticsIdentifier)
      setAnalyticsIdentifier(result?.client?.id)
      setBooking(result)
      setLoading(false);
    },
    [serviceId],
  );

  useEffect(() => {
    fetchAuthOrBooking()
    generateDeeplink({ campaign: 'existing user', tags: ['desktop', 'customtag2'], data: { serviceId: serviceId, identityMatch } })
  }, [serviceId]);

  useRunOnce(() => {
    testLogEventWhitelabel(serviceId, medium, "viewed existing account/account linking")
  })


  const renderRightMessage = useMemo(() => {
    let message = <>
      <Typography variant="body2" gutterBottom >
        {validationMessage}
      </Typography>
      <Typography variant="body2" gutterBottom className={classes.strong}>
        Scan the code or click the link below to continue.
      </Typography>

      <Button
        underline="none"
        variant="contained"
        color="primary"
        onClick={() => {
          trackEvent('existing account - click Open App', { booking_id: match?.params?.serviceId })
          window.location.href = identityResult?.app_link
        }}
      >
        Open App
      </Button>

    </>


    return <Typography variant="body2" gutterBottom>{message}</Typography>
  }, [classes.strong, identityResult?.app_link, validationMessage]);

  const renderLeftMessage = useMemo(() => {
    let message = <></>
    switch (identityMatch) {
      case 'name':
        message = <><Typography align="center" variant="h2" gutterBottom className={clsx(classes.helvetica, classes.title)}>You may have an existing zennya account</Typography>
          {!isMobile && <Typography align="center" variant="body1" gutterBottom color=''>If you already have an account, please log in through the zennya app to verify as the owner of the account </Typography>}
        </>
        break;

      default:
        message = <><Typography align="center" variant="h2" gutterBottom className={clsx(classes.helvetica, classes.title)}>We found an existing zennya account</Typography>
          <Typography align="center" variant="body1" gutterBottom color=''>Log in through the app to continue</Typography></>
    }
    return message
  }, [classes.helvetica, classes.title, identityMatch, isMobile]);


  const [pinCode, setPinCode] = useState(new Array(6).fill(''));
  const [invalidCode, setInvalidCode] = useState();
  const [confirming, setConfirming, confirmingRef] = useState(false);
  const { loginPinCodeWithoutClient } = useUserState()

  const [isValid, setIsValid] = useState(false);



  const sendVerification = useCallback(
    async () => {
      const result = await requestWhitelabelVerification(whiteLabelCustomerId, serviceId)
      setIdentityResult(result)
    }, [whiteLabelCustomerId, serviceId],
  );

  const confirmCode = useCallback(
    async (pin) => {
      if (confirmingRef.current) return
      setConfirming(true)
      setInvalidCode()
      const params = {
        identifier: whiteLabelCustomerId,
        code: pin,
        fingerprint: fingerprint
      }
      let result
      try {
        await loginPinCodeWithoutClient(params)
        setIsValid(true)
        return
      } catch (e) {
        if (e?.response?.status === 400) {
          setInvalidCode('Invalid Pin Code')
          setIsValid(false)
        }
      }
      setPinCode(new Array(6).fill(''))
      setConfirming(false)
    }, [confirmingRef, loginPinCodeWithoutClient, setConfirming, whiteLabelCustomerId],
  );

  useEffect(() => {
    sendVerification()
  }, [location?.state]);

  if (!validationState) {
    return <Redirect to={{
      ...history.location,
      pathname: `/bookings/login/${serviceId}`
    }} />
  }
  if (!serviceId) {
    return <BookingNotFound />
  }

  if (isValid) {
    return <Redirect to={{
      ...history.location,
      pathname: `/bookings/${serviceId}`
    }} />
  }
  if (isEmpty(location?.state)) {
    <Redirect replace to={{
      ...history.location,
      pathname: `/bookings/login/${serviceId}`
    }} />
  }
  return (
    <>
      <CustomToaster
        onChatOpen={() => {
          setChatOpen(SUPPORT_CHAT)
        }}
      />
      <Container maxWidth="md" className={classes.centerCard} disableGutters>
        <HeaderPillow whiteLabelPartner={booking?.white_label_partner} />
        <div className={classes.root}>
          <Box className={classes.roundBack}>
            <MuiThemeProvider theme={themes.dark}>
              <Paper elevation={0} className={classes.leftBox}>
                <Container fixed>
                  {renderLeftMessage}
                </Container>
                {!isMobile &&
                  (
                    <MuiThemeProvider theme={themes.default}>
                      <Card variant="outlined" className={classes.qrBox}>
                        <CardHeader
                          classes={{
                            root: classes.cardHeader
                          }}
                          title="Scan to open the app" />
                        <CardContent>
                          <Qrcode value={identityResult?.app_link ?? ""} renderAs="svg" size={256} />
                        </CardContent>

                      </Card>
                    </MuiThemeProvider>
                  )
                }
              </Paper>
            </MuiThemeProvider>
            <Box className={classes.rightBox}>
              <Box className={classes.bookingBox}>
                <>
                  {renderRightMessage}
                  {/* <div className={classes.code}>
                    <PinInput
                      inputClassName={classes.codeInput}
                      values={pinCode}
                      size="md"
                      placeholder=""
                      onChange={(char, index, pinString) => {
                        setPinCode(pinString)
                      }}
                      onComplete={(v) => {
                        confirmCode(v.join(''))
                      }} />
                    <div className={classes.action}>
                      {invalidCode && <Typography variant="caption" color="error">{invalidCode}</Typography>}
                      <Button
                        disabled={confirming}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          sendVerification()
                        }}
                      >Resend OTP</Button>
                    </div>
                  </div> */}
                </>
              </Box>
              <Box className={classes.handBox}>
                <img src='/assets/images/hand2.png' />
              </Box>
            </Box>
          </Box>
        </div>
      </Container >
      {/* <Chat disableMedical serviceId={serviceId} /> */}
    </>
  )
}

export { ExistingAccount };
